import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { EqualMark } from "@/components/brand";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const REDIRECT_DELAY_MS = 800; // ms before redirect after successful auth

export default function GoogleCallback() {
  const [status, setStatus] = useState("Completing sign in...");
  const navigate = useNavigate();

  useEffect(() => {
    const processAuth = async () => {
      // Check both hash (#session_id=) and query params (?session_id=)
      let sessionId = null;

      const hash = window.location.hash;
      if (hash) {
        const hashParams = new URLSearchParams(hash.substring(1));
        sessionId = hashParams.get("session_id");
      }

      if (!sessionId) {
        const queryParams = new URLSearchParams(window.location.search);
        sessionId = queryParams.get("session_id");
      }

      if (!sessionId) {
        toast.error("Authentication failed — no session ID received. Please try again.");
        navigate("/");
        return;
      }

      try {
        setStatus("Verifying your account...");
        const response = await axios.post(
          `${API}/auth/google-callback?session_id=${sessionId}`,
          {},
          { withCredentials: true }
        );

        const { user, token } = response.data;

        // Store JWT token + user info
        if (token) localStorage.setItem("token", token);
        localStorage.setItem("email", user.email);
        localStorage.setItem("role", user.role);

        setStatus("Unlocking your portal...");
        toast.success(`Welcome ${user.name || user.email}!`);

        window.history.replaceState({}, document.title, "/home");

        setTimeout(() => {
          if (user.role === "admin") navigate("/admin", { replace: true });
          else if (user.role === "city_official") navigate("/city", { replace: true });
          else navigate("/home", { replace: true });
        }, REDIRECT_DELAY_MS);

      } catch (error) {
        const detail = error.response?.data?.detail || "Authentication failed. Please try again.";
        toast.error(detail);
        navigate("/");
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-page">
      <div className="card-flat px-10 py-10 flex flex-col items-center gap-5 animate-rise-in">
        <div className="relative">
          <div className="absolute inset-0 rounded-full border border-equal/40 animate-ping scale-150" />
          <div className="p-3 rounded-xl bg-white border border-line">
            <EqualMark size={40} />
          </div>
        </div>
        <div className="text-center">
          <p className="text-ink font-bold text-base tracking-tight">
            Equal
          </p>
          <p className="eyebrow mt-1 animate-pulse">{status}</p>
        </div>
      </div>
    </div>
  );
}
